<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
    <label for="{{zipControlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!labelZip" i18n="@@zip">Zip</span>
      <span *ngIf="labelZip">{{labelZip}}</span>&nbsp;<span *ngIf="showRequired && required">*</span>
    </label>

    <mat-form-field style="width:100%">
      <input id="{{zipControlId}}" type="text" matInput [formControlName]="zipControlName"
             [matAutocomplete]="zipAutoComplete" [readOnly]="readonly" (keypress)="keypress($event)">
      <mat-error *ngIf="zipShowInvalid && zipControl?.hasError('required')" i18n="@@requiredInput">
        This input is required.
      </mat-error>
      <mat-error *ngIf="zipShowInvalid && zipControl?.hasError('maxlength')" i18n="@@zipMaxLen">
        Zip must be at most 6 characters long
      </mat-error>
      <mat-error *ngIf="zipShowInvalid && zipControl?.hasError('minlength')" i18n="@@zipMinLen">
        Zip must be at least 4 characters long
      </mat-error>
    </mat-form-field>

    <mat-autocomplete #zipAutoComplete="matAutocomplete" [displayWith]="displayZip" (optionSelected)="onChange($event)">
      <mat-option *ngFor="let t of townships" [value]="t">
        <span>{{ t?.zip }} - {{ t?.name }}</span>
      </mat-option>
    </mat-autocomplete>
  </div>

  <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <label for="{{townshipNameControlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!labelTownshipName" i18n="@@township">Township</span>
      <span *ngIf="labelTownshipName">{{labelTownshipName}}</span>&nbsp;<span *ngIf="showRequired && required">*</span>
    </label>

    <input id="{{townshipNameControlId}}" type="text" class="form-control text-uppercase" [readOnly]="true"
           [formControlName]="townshipNameControlName">
  </div>
</div>
